import { Box, Chip } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar, { ToolbarProps } from '@mui/material/Toolbar';
import { FormattedMessage } from 'react-intl';
import useSelectedPatient from '~/hooks/patient/useSelectedPatient';
import AppConfig from '~/utils/appconfig';
import WorkspaceHorizonLogo from '../Logo/WorkspaceHorizonLogo';
import ApplicationQuickMenu from './ApplicationQuickMenu';
import PatientMenu from './PatientMenu';

export default function Header({ ...toolbarProps }: ToolbarProps) {
    const selectedPatient = useSelectedPatient();

    return (
        <AppBar
            elevation={0}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                background: (theme) => theme.palette.background.default,
                height: 56,
                minHeight: 56,
            }}
        >
            <Toolbar
                {...toolbarProps}
                variant="dense"
                sx={{
                    display: 'flex',
                    gap: 1,
                    mx: 1,
                    ml: 1.5,
                    height: 56,
                    minHeight: 56,
                }}
            >
                <Box
                    flexGrow="1"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Box display="flex" alignItems="center" gap={2}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <WorkspaceHorizonLogo height={26} />
                        </Box>
                        {selectedPatient && (
                            <PatientMenu patient={selectedPatient} />
                        )}
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        {!AppConfig.clinicalUse && (
                            <Chip
                                variant="outlined"
                                size="small"
                                color="warning"
                                sx={{
                                    px: 0.5,
                                    minHeight: 0,
                                    height: 20,
                                    fontSize: 11,
                                }}
                                label={
                                    <FormattedMessage id="notForClinicalUse" />
                                }
                            />
                        )}
                        <ApplicationQuickMenu />
                    </Box>
                </Box>
            </Toolbar>
        </AppBar>
    );
}
